/* Иконка лупы (поиска) */
export const IconLoupe = ({
  width = 36,
  height = 36,
  fill = 'currentColor',
  viewBox = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || `0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M35.1875 31.3906L26.3641 22.5656C27.9164 20.2654 28.7447 17.5532 28.7422 14.7781C28.7422 7.07812 22.4797 0.8125 14.7781 0.8125C7.07812 0.8125 0.8125 7.07812 0.8125 14.7781C0.8125 22.4797 7.07812 28.7437 14.7781 28.7437C17.5533 28.747 20.2658 27.9187 22.5656 26.3656L31.3875 35.1875L35.1875 31.3906ZM14.7781 24.4453C12.2146 24.4428 9.75673 23.4234 7.94403 21.6107C6.13132 19.798 5.11186 17.3401 5.10938 14.7766C5.11227 12.2131 6.13187 9.75554 7.94448 7.94292C9.7571 6.13031 12.2147 5.11071 14.7781 5.10781C17.3415 5.11071 19.7992 6.13031 21.6118 7.94292C23.4244 9.75554 24.444 12.2131 24.4469 14.7766C24.444 17.34 23.4244 19.7976 21.6118 21.6102C19.7992 23.4228 17.3415 24.4424 14.7781 24.4453Z" />
    </svg>
  );
};

export const IconCloseFieldSearch = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 8L20 20" strokeWidth="2" stroke={'currentColor'} />
      <path d="M8 20L20 8" strokeWidth="2" stroke={'currentColor'} />
    </svg>
  );
};

export const IconPerson = ({ width = 34, height = 36, fill = 'black', viewBox = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || `0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.08333 7.99992C9.08333 5.90029 9.91741 3.88665 11.4021 2.40199C12.8867 0.917327 14.9004 0.083252 17 0.083252C19.0996 0.083252 21.1133 0.917327 22.5979 2.40199C24.0826 3.88665 24.9167 5.90029 24.9167 7.99992C24.9167 10.0995 24.0826 12.1132 22.5979 13.5978C21.1133 15.0825 19.0996 15.9166 17 15.9166C14.9004 15.9166 12.8867 15.0825 11.4021 13.5978C9.91741 12.1132 9.08333 10.0995 9.08333 7.99992ZM0.75 34.6666C0.75 25.6916 8.025 18.4166 17 18.4166C25.975 18.4166 33.25 25.6916 33.25 34.6666C33.25 34.9981 33.1183 35.316 32.8839 35.5505C32.6495 35.7849 32.3315 35.9166 32 35.9166H2C1.66848 35.9166 1.35054 35.7849 1.11612 35.5505C0.881696 35.316 0.75 34.9981 0.75 34.6666Z" />
    </svg>
  );
};

export const IconMenu = ({ width = 32, height = 28, fill = 'black', viewBox = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || `0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.376562 0.137597L0.375 5.30947L31.6219 5.30166L31.625 0.131348L0.376562 0.137597ZM0.376562 22.697L0.375 27.8688L31.6219 27.8595L31.625 22.6907L0.376562 22.697ZM0.376562 11.4079L0.375 16.5782L31.6219 16.572L31.625 11.4017L0.376562 11.4079Z" />
    </svg>
  );
};

/* Фирменный лого */
export const IconStar = ({ width = 90, height = 83, fill = '#EB2F2C', viewBox = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || `0 0 ${width} ${height}`}
      fill={'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.4447 45.397L58.771 64.5205L44.9901 54.6596L30.5692 64.5205L37.16 45.397H19.2434L27.6048 51.3512L17.1865 82.7461L44.9901 63.4312L72.7726 82.7461L62.3544 51.3512L70.7595 45.397H52.4447Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.57794 38.5036H39.5269L44.9903 22.6891L50.1884 38.5036H80.426L89.9382 31.7169H55.6964L44.9903 0.216064L34.263 31.7169H0L9.57794 38.5036Z"
      />
    </svg>
  );
};
